// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__AZWBf","text":"styles_text__FyLtc"};